var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main-app"}},[_c('ZHeader',{attrs:{"menu":_vm.menu}}),_c('router-view'),_c('ZFooter',{attrs:{"menu":_vm.menu}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }